import './App.css';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Home from './components/Home';
import Produit from './pages/Produit';
import Panier from './pages/Panier';
import Paiement from './pages/Paiement';
import Contact from './pages/Contact';
import InformationsClient from './pages/Information_client';
// import Login from './pages/Auth/login';
import AdminPage from './pages/admin/AdminPage';
import PrivateRouteAdmin from './components/admin/PrivateRouteAdmin';
import PrivateRouteVendeur from './components/vendeur/PrivateRouteVendeur';
import AdminLogin from './pages/admin/AdminLogin';
import VendeurLogin from './pages/vendeur/VendeurLogin';
import VendeurRegisterForm from './components/vendeur/VendeurRegisterForm';
import VendeurLayout from './pages/vendeur/layout/VendeurLayout';
import VendeurAccueil from './pages/vendeur/VendeurAccueil';
import MesProduits from './pages/vendeur/pages/MesProduits';
import AjouterProduit from './pages/vendeur/pages/AjouterProduit';
import EditProduit from './pages/vendeur/pages/EditProduit';
import ProduitsEnAttente from './components/admin/ProduitsEnAttente';
import ProduitsValides from './components/admin/ProduitsValides';
import CategorieProduits from './components/CategorieProduits';

// import { getWelcomeMessage } from './services/api';
import { PanierProvider } from './context/PanierContext';
import CommandesVendeur from './pages/vendeur/pages/CommandesVendeur';
import CGV from './pages/accueil/CGV';
import Confidentialite from './pages/accueil/confidentialite';
import VendeurNotifications from './pages/vendeur/pages/VendeurNotifications';
import VerifyPage from './pages/VerifyPageAccueil';
import MesCommandes from './pages/accueil/MesCommandes';
import Favoris from './pages/Favoris';
import Categorie from './pages/Categorie';
import ProfilClient from './pages/ProfilClient';

function App() {
  const [data,setData] = useState('');
  const location = useLocation();

  const hideLayoutRoutes = ['/admin/login','/vendeur', '/admin'];
  const hideLayout = hideLayoutRoutes.some(path => location.pathname.startsWith(path));

//  useEffect(() => {
//   const fetchData = async () => {
//     const message = await getWelcomeMessage();
//     if (message) {
//       setData(message);
//     }
//   };
//   fetchData();
// }, []);

  return (
    <PanierProvider>
      <div className="App">
        {!hideLayout && <NavBar />}

         <main className="main-content">
          <Routes>
 <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/produits" element={<Produit />} />
          <Route path="/categories" element={<Categorie />} />
          <Route path="/information" element={<InformationsClient />} />
          <Route path="/panier" element={<Panier />} />
          <Route path="/paiement" element={<Paiement />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/vendeur/login" element={<VendeurLogin />} />
          <Route path='/categorie/:id' element={<CategorieProduits/>} />
          <Route path="/vendeur/inscription" element={<VendeurRegisterForm />} />
          <Route path='/admin/produits/en-attente' element={<ProduitsEnAttente/>} />
          <Route path='/produits-valides' element={<ProduitsValides/>}/>
          <Route path='/mes-commandes' element={<MesCommandes/>}/>
          <Route path='/profil' element={<ProfilClient/>}/>
          <Route path='/favoris' element={<Favoris/>} />
          <Route path="/connexion" element={<InformationsClient />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/verify" element={<VerifyPage />} />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <PrivateRouteAdmin>
                <AdminPage />
              </PrivateRouteAdmin>
            }
          />

          {/* Vendeur Routes protégées */}
          <Route path="/vendeur" element={<PrivateRouteVendeur />}>
            <Route element={<VendeurLayout />}>
              <Route index element={<Navigate to="accueil" />} />
              <Route path="accueil" element={<VendeurAccueil />} />
              <Route path="produits" element={<MesProduits />} />
              <Route path="categories" element={<Categorie/>} />
              <Route path="produits/ajouter" element={<AjouterProduit />} />
              <Route path="produits/edit/:id" element={<EditProduit />} />
              <Route path="commandes" element={<CommandesVendeur />} />
              <Route path="/vendeur/notifications" element={<VendeurNotifications />} />
            </Route>
          </Route>          
          </Routes>
        </main>

        {!hideLayout && <Footer />}
      </div>
    </PanierProvider>
  );
}

export default App;
